export const GET_STOCK_STATUS_REQUEST = 'GET_STOCK_STATUS_REQUEST';
export const GET_STOCK_STATUS_DATA = 'GET_STOCK_STATUS_DATA';
export const GET_STOCK_STATUS_ERROR = 'GET_STOCK_STATUS_ERROR';

export const SET_STOCK_HISTORY_SORT_DATA = 'SET_STOCK_HISTORY_SORT_DATA';
export const SORTING_STOCK_HISTORY_ACTION = 'SORTING_STOCK_HISTORY_ACTION';

export const CREATE_STOCK_STATUS_REQUEST = 'CREATE_STOCK_STATUS_REQUEST';
export const CREATE_STOCK_STATUS_DATA = 'CREATE_STOCK_STATUS_DATA';
export const CREATE_STOCK_STATUS_ERROR = 'CREATE_STOCK_STATUS_ERROR';

export const UPDATE_STOCK_STATUS_REQUEST = 'UPDATE_STOCK_STATUS_REQUEST';
export const UPDATE_STOCK_STATUS_DATA = 'UPDATE_STOCK_STATUS_DATA';
export const UPDATE_STOCK_STATUS_ERROR = 'UPDATE_STOCK_STATUS_ERROR';

export const DELETE_STOCK_STATUS_REQUEST = 'DELETE_STOCK_STATUS_REQUEST';
export const DELETE_STOCK_STATUS_DATA = 'DELETE_STOCK_STATUS_DATA';
export const DELETE_STOCK_STATUS_ERROR = 'DELETE_STOCK_STATUS_ERROR';